import React, { useState, useEffect } from 'react';
import { ContextMenu, ContextMenuTrigger, MenuItem } from 'react-contextmenu';
import crypto from 'crypto'

import './ContextMenu_common.css'
import Axios from 'axios';
import { apiServerHost } from '../common/APIServerSettings';

const OverlayMenu = (props) => {
  const { children, id, name, value, resource, sendable } = props;
  const { onInput, onUpdate, onShow, onHide } = props;
  
  const [ _name, setName ] = useState(name)
  const [ _value, setValue ] = useState(value)
  const [ _resource, setResource ] = useState(resource)
  const [ _sendable, setSendable ] = useState(sendable)
  let [ lazyUpdate_timeout, setLazyUpdate_timeout ] = useState(null)

  // const lazyUpdateTimeout = (propName, value) => {
  //   clearTimeout(lazyUpdate_timeout)
  //   setLazyUpdate_timeout(setTimeout(() => {
  //     onLazyUpdate({
  //       [propName]: value
  //     })
  //     setLazyUpdate_timeout(null)
  //     // console.log("Module action 실행 => ", )
  //   }, 300))
  // }

  // 이미지 Input onChange 핸들링
  const onChange_imageInput = (e) => {
    const { files } = e.target
    if (files) {
      if (files[0]) {
        setResource(files[0])
        uploadImage(files[0], callBack_imageUploaded)
        return
      }
    }
    // window.alert("이미지를 업로드하지 못했습니다.")
  }

  // 이미지 업로드 Http요청 콜백
  const callBack_imageUploaded = (response) => {
    const { data } = response
    const { statusCode } = data
    if (statusCode === 200) {
      const { property } = data 
      const { imageName } = property
      onUpdate("resource", imageName)
      return
    }
    alert("이미지를 업로드하지 못했습니다.")
  }
  // Overlay 메뉴 고유 ID
  const OverlayMenuId = "OverlayMenu_" + crypto.randomBytes(2).toString('hex')

  const render_MenuItem = (name, value, resource, sendable) => {
    const rendered = []
    if (name || name === "") {
      rendered.push(
        <MenuItem key={0} preventClose={true}>
          <div className="attr-row">
            <div>
              이름
            </div>
            <div>
              <input placeholder="이름을 입력해주세요" value={name} 
                onChange={(e) => { setName(e.target.value);onUpdate("name", e.target.value); }} 
                />
            </div>
          </div>
        </MenuItem>
      )
    }
    
    if (value || value === "") {
      rendered.push(
        <MenuItem key={1} preventClose={true}>
          <div className="attr-row">
            <div>
              값
            </div>
            <div>
              <input placeholder="값을 입력해주세요" value={value} 
                onChange={(e) => { setValue(e.target.value);onUpdate("value", e.target.value); }} 
                />
            </div>
          </div>
        </MenuItem>
      )
    }
    if (resource !== undefined) {
      rendered.push(
        <MenuItem key={2} preventClose={true}>
          <div className="attr-row">
            <div>
              이미지
            </div>
            <div>
              <input type="file" placeholder="이미지 업로드" onChange={onChange_imageInput}  />
            </div>
          </div>
        </MenuItem>
      )
    }
    return rendered
  }
  return (
    <div>
      <ContextMenuTrigger id={OverlayMenuId}>
        {children}
      </ContextMenuTrigger>
      <ContextMenu 
        id={OverlayMenuId} 
        className="overlay-component-menu" 
        preventHideOnScroll={false}
        onShow={onShow}
        onHide={onHide}>
        {render_MenuItem(_name, _value, _resource, _sendable)}
        {/* <p> {lazyUpdate_timeout ? "updating..." : "OK!"} </p> */}
      </ContextMenu>
    </div>
  )
}

const uploadImage = (image, callback) => {
  // http request ...
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
  const formData = new FormData()
  formData.append("file", image)
  Axios.post(`${apiServerHost}/manage/topic/topicbuilder/upload/imageUpload.do`, formData, config)
  .then((response) => {
    callback(response)
  })
  .catch((e) => {
    alert("이미지를 업로드하지 못했습니다. http exception")
  })
}

export default OverlayMenu